// @flow
import React, { Component } from 'react';
import {
  Text, TextArea, Checkbox, Radio, RadioGroup, Select, Option,
} from 'informed';
import NumericText from '../../../NumericText.jsx';

import { PrimaryText, SecondaryText } from '../../../Typography.jsx';
import ContentBox from '../../../ContentBox.jsx';
import { Button } from '../../../Buttons.jsx';

import styles from '../../../../styles/patientPages/progressNote/progressNote.scss';

type Props = {
  initCardiovascular: Object,
  handleBPChange: Function,
  resetPulsesRadios: Function,
  resetTissuePerfusionRadios: Function,
}

const publicUrl = process.env.PUBLIC_URL || '';

class EditCardiovascular extends Component<Props> {
  render() {
    const cardiovascular = this.props.initCardiovascular || {};
    return (
      <ContentBox title='Cardiovascular'>
        <div className={styles.col}>
          <PrimaryText>Pulses</PrimaryText><br />
          <Button onClick={this.props.resetPulsesRadios}>Clear Radios</Button>
          <div className={styles.section}>
            <table>
              <tbody className={styles.topAlign}>
                <tr>
                  <td><SecondaryText>Apical: </SecondaryText></td>
                  <td>
                    <RadioGroup field='cardiovascular.apical' initialValue={cardiovascular.apical}>
                      <Radio value='regular' />Regular<br />
                      <Radio value='irregular' />Irregular
                    </RadioGroup>
                  </td>
                </tr>
                <tr>
                  <td><SecondaryText>Murmur noted: </SecondaryText></td>
                  <td>
                    <RadioGroup field='cardiovascular.murmur' initialValue={cardiovascular.murmur}>
                      <Radio value='yes' />Yes<br />
                      <Radio value='no' />No
                    </RadioGroup>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <PrimaryText>Carotid/Peripheral Pulses</PrimaryText>
          <div className={styles.section}>
            <img src={`${publicUrl}/sa_assets/pulses.png`} alt='pulses' width="400px" />
            <table>
              <tbody>
                <tr>
                  <td>Left Carotid</td>
                  <td>
                    <Select field='cardiovascular.leftCarotidPulse' initialValue={cardiovascular.leftCarotidPulse}>
                      <Option value=''>Select Value...</Option>
                      <Option value='4'>4+ Bounding</Option>
                      <Option value='3'>3+ Full, increased</Option>
                      <Option value='2'>2+ Expected</Option>
                      <Option value='1'>1+ Thready/weak</Option>
                      <Option value='0'>0 Not palpable</Option>
                    </Select>
                  </td>
                  <td>
                    <Checkbox field='cardiovascular.leftCarotidMurmur' initialValue={cardiovascular.leftCarotidMurmur} />Murmur
                  </td>
                </tr>
                <tr>
                  <td>Right Carotid</td>
                  <td>
                    <Select field='cardiovascular.rightCarotidPulse' initialValue={cardiovascular.rightCarotidPulse}>
                      <Option value=''>Select Value...</Option>
                      <Option value='4'>4+ Bounding</Option>
                      <Option value='3'>3+ Full, increased</Option>
                      <Option value='2'>2+ Expected</Option>
                      <Option value='1'>1+ Thready/weak</Option>
                      <Option value='0'>0 Not palpable</Option>
                    </Select>
                  </td>
                  <td>
                    <Checkbox field='cardiovascular.rightCarotidMurmur' initialValue={cardiovascular.rightCarotidMurmur} />Murmur
                  </td>
                </tr>
                <tr>
                  <td>Left Branchial</td>
                  <td>
                    <Select field='cardiovascular.leftBranchialPulse' initialValue={cardiovascular.leftBranchialPulse}>
                      <Option value=''>Select Value...</Option>
                      <Option value='4'>4+ Bounding</Option>
                      <Option value='3'>3+ Full, increased</Option>
                      <Option value='2'>2+ Expected</Option>
                      <Option value='1'>1+ Thready/weak</Option>
                      <Option value='0'>0 Not palpable</Option>
                    </Select>
                  </td>
                </tr>
                <tr>
                  <td>Right Branchial</td>
                  <td>
                    <Select field='cardiovascular.rightBranchialPulse' initialValue={cardiovascular.rightBranchialPulse}>
                      <Option value=''>Select Value...</Option>
                      <Option value='4'>4+ Bounding</Option>
                      <Option value='3'>3+ Full, increased</Option>
                      <Option value='2'>2+ Expected</Option>
                      <Option value='1'>1+ Thready/weak</Option>
                      <Option value='0'>0 Not palpable</Option>
                    </Select>
                  </td>
                </tr>
                <tr>
                  <td>Left Radial</td>
                  <td>
                    <Select field='cardiovascular.leftRadialPulse' initialValue={cardiovascular.leftRadialPulse}>
                      <Option value=''>Select Value...</Option>
                      <Option value='4'>4+ Bounding</Option>
                      <Option value='3'>3+ Full, increased</Option>
                      <Option value='2'>2+ Expected</Option>
                      <Option value='1'>1+ Thready/weak</Option>
                      <Option value='0'>0 Not palpable</Option>
                    </Select>
                  </td>
                </tr>
                <tr>
                  <td>Right Radial</td>
                  <td>
                    <Select field='cardiovascular.rightRadialPulse' initialValue={cardiovascular.rightRadialPulse}>
                      <Option value=''>Select Value...</Option>
                      <Option value='4'>4+ Bounding</Option>
                      <Option value='3'>3+ Full, increased</Option>
                      <Option value='2'>2+ Expected</Option>
                      <Option value='1'>1+ Thready/weak</Option>
                      <Option value='0'>0 Not palpable</Option>
                    </Select>
                  </td>
                </tr>
                <tr>
                  <td>Left Femoral</td>
                  <td>
                    <Select field='cardiovascular.leftFemoralPulse' initialValue={cardiovascular.leftFemoralPulse}>
                      <Option value=''>Select Value...</Option>
                      <Option value='4'>4+ Bounding</Option>
                      <Option value='3'>3+ Full, increased</Option>
                      <Option value='2'>2+ Expected</Option>
                      <Option value='1'>1+ Thready/weak</Option>
                      <Option value='0'>0 Not palpable</Option>
                    </Select>
                  </td>
                </tr>
                <tr>
                  <td>Right Femoral</td>
                  <td>
                    <Select field='cardiovascular.rightFemoralPulse' initialValue={cardiovascular.rightFemoralPulse}>
                      <Option value=''>Select Value...</Option>
                      <Option value='4'>4+ Bounding</Option>
                      <Option value='3'>3+ Full, increased</Option>
                      <Option value='2'>2+ Expected</Option>
                      <Option value='1'>1+ Thready/weak</Option>
                      <Option value='0'>0 Not palpable</Option>
                    </Select>
                  </td>
                </tr>
                <tr>
                  <td>Left Popliteal</td>
                  <td>
                    <Select field='cardiovascular.leftPoplitealPulse' initialValue={cardiovascular.leftPoplitealPulse}>
                      <Option value=''>Select Value...</Option>
                      <Option value='4'>4+ Bounding</Option>
                      <Option value='3'>3+ Full, increased</Option>
                      <Option value='2'>2+ Expected</Option>
                      <Option value='1'>1+ Thready/weak</Option>
                      <Option value='0'>0 Not palpable</Option>
                    </Select>
                  </td>
                </tr>
                <tr>
                  <td>Right Popliteal</td>
                  <td>
                    <Select field='cardiovascular.rightPoplitealPulse' initialValue={cardiovascular.rightPoplitealPulse}>
                      <Option value=''>Select Value...</Option>
                      <Option value='4'>4+ Bounding</Option>
                      <Option value='3'>3+ Full, increased</Option>
                      <Option value='2'>2+ Expected</Option>
                      <Option value='1'>1+ Thready/weak</Option>
                      <Option value='0'>0 Not palpable</Option>
                    </Select>
                  </td>
                </tr>
                <tr>
                  <td>Left Posterior Tibial</td>
                  <td>
                    <Select field='cardiovascular.leftPosteriorTibialPulse' initialValue={cardiovascular.leftPosteriorTibialPulse}>
                      <Option value=''>Select Value...</Option>
                      <Option value='4'>4+ Bounding</Option>
                      <Option value='3'>3+ Full, increased</Option>
                      <Option value='2'>2+ Expected</Option>
                      <Option value='1'>1+ Thready/weak</Option>
                      <Option value='0'>0 Not palpable</Option>
                    </Select>
                  </td>
                </tr>
                <tr>
                  <td>Right Posterior Tibial</td>
                  <td>
                    <Select field='cardiovascular.rightPosteriorTibialPulse' initialValue={cardiovascular.rightPosteriorTibialPulse}>
                      <Option value=''>Select Value...</Option>
                      <Option value='4'>4+ Bounding</Option>
                      <Option value='3'>3+ Full, increased</Option>
                      <Option value='2'>2+ Expected</Option>
                      <Option value='1'>1+ Thready/weak</Option>
                      <Option value='0'>0 Not palpable</Option>
                    </Select>
                  </td>
                </tr>
                <tr>
                  <td>Left Dorsalis Pedis</td>
                  <td>
                    <Select field='cardiovascular.leftDorsalisPedisPulse' initialValue={cardiovascular.leftDorsalisPedisPulse}>
                      <Option value=''>Select Value...</Option>
                      <Option value='4'>4+ Bounding</Option>
                      <Option value='3'>3+ Full, increased</Option>
                      <Option value='2'>2+ Expected</Option>
                      <Option value='1'>1+ Thready/weak</Option>
                      <Option value='0'>0 Not palpable</Option>
                    </Select>
                  </td>
                </tr>
                <tr>
                  <td>Right Dorsalis Pedis</td>
                  <td>
                    <Select field='cardiovascular.rightDorsalisPedisPulse' initialValue={cardiovascular.rightDorsalisPedisPulse}>
                      <Option value=''>Select Value...</Option>
                      <Option value='4'>4+ Bounding</Option>
                      <Option value='3'>3+ Full, increased</Option>
                      <Option value='2'>2+ Expected</Option>
                      <Option value='1'>1+ Thready/weak</Option>
                      <Option value='0'>0 Not palpable</Option>
                    </Select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <PrimaryText>Ankle-Brachial Index Test</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Blood pressure measurements</SecondaryText><br />
            <table>
              <tbody>
                <tr>
                  <td>Right arm systolic blood pressure: </td>
                  <td><Text field='cardiovascular.rightArmSysBP' initialValue={cardiovascular.rightArmSysBP} size={4} onChange={this.props.handleBPChange} /></td>
                  <td> mmHg</td>
                </tr>
                <tr>
                  <td>Left arm systolic blood pressure: </td>
                  <td><NumericText field='cardiovascular.leftArmSysBP' initialValue={cardiovascular.leftArmSysBP} size={4} onChange={this.props.handleBPChange} /></td>
                  <td> mmHg</td>
                </tr>
                <tr>
                  <td>Right ankle systolic pressure posterior tibial: </td>
                  <td><NumericText field='cardiovascular.rightAnkleSysBPPostTib' initialValue={cardiovascular.rightAnkleSysBPPostTib} size={4} onChange={this.props.handleBPChange} /></td>
                  <td> mmHg</td>
                </tr>
                <tr>
                  <td>Right ankle systolic pressure dorsalis pedis: </td>
                  <td><NumericText field='cardiovascular.rightAnkleSysBPDorsPed' initialValue={cardiovascular.rightAnkleSysBPDorsPed} size={4} onChange={this.props.handleBPChange} /></td>
                  <td> mmHg</td>
                </tr>
                <tr>
                  <td>Left ankle systolic pressure posterior tibial: </td>
                  <td><NumericText field='cardiovascular.leftAnkleSysBPPostTib' initialValue={cardiovascular.leftAnkleSysBPPostTib} size={4} onChange={this.props.handleBPChange} /></td>
                  <td> mmHg</td>
                </tr>
                <tr>
                  <td>Left ankle systolic pressure dorsalis pedis: </td>
                  <td><NumericText field='cardiovascular.leftAnkleSysBPDorsPed' initialValue={cardiovascular.leftAnkleSysBPDorsPed} size={4} onChange={this.props.handleBPChange} /></td>
                  <td> mmHg</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className={styles.section}>
            <SecondaryText>Calculate ankle-brachial index</SecondaryText><br />
            Divide the highest pressure systolic pressure in each leg by the highest systolic brachial pressure<br />
            <table>
              <tbody>
                <tr>
                  <td>Right index score: </td>
                  <td><Text field='cardiovascular.rightIndexScore' disabled initialValue={cardiovascular.rightIndexScore} size={8} className={styles.disabledText} /></td>
                </tr>
                <tr>
                  <td>Left index score: </td>
                  <td><Text field='cardiovascular.leftIndexScore' disabled initialValue={cardiovascular.leftIndexScore} size={8} className={styles.disabledText} /></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className={styles.section}>
            <SecondaryText>Interpretation</SecondaryText><br />
            Above 0.90: Normal<br />
            0.71-0.90: Mild obstruction<br />
            0.41-0.70: Moderate obstruction<br />
            0.00-0.40: Severe obstruction
          </div>
          <PrimaryText>Tissue Perfusion</PrimaryText><br />
          <Button onClick={this.props.resetTissuePerfusionRadios}>Clear Radios</Button>
          <div className={styles.section}>
            <SecondaryText>Peripheral vascular, general (mark all that apply):</SecondaryText><br />
            <Checkbox field='cardiovascular.warm' initialValue={cardiovascular.warm} />Warm extremities<br />
            <Checkbox field='cardiovascular.cold' initialValue={cardiovascular.cold} />Cold extremities<br />
            <Checkbox field='cardiovascular.pale' initialValue={cardiovascular.pale} />Pale extremities<br />
            <Checkbox field='cardiovascular.cyanotic' initialValue={cardiovascular.cyanotic} />Cyanotic extremities<br />
            <Checkbox field='cardiovascular.discoloration' initialValue={cardiovascular.discoloration} />Discoloration of legs with activity/walking<br />
            <Checkbox field='cardiovascular.legPain' initialValue={cardiovascular.legPain} />Leg pain<br />
            <Checkbox field='cardiovascular.calfTender' initialValue={cardiovascular.calfTender} />Calf tenderness<br />
            Other:<br />
            <TextArea field='cardiovascular.otherPeripheralVascular' initialValue={cardiovascular.otherPeripheralVascular} /><br />
          </div>
          <div className={styles.section}>
            <SecondaryText>Capillary refill</SecondaryText><br />
            <table>
              <tbody className={styles.topAlign}>
                <tr>
                  <td>Left hand: </td>
                  <td>
                    <RadioGroup field='cardiovascular.capRefillLeftHand' initialValue={cardiovascular.capRefillLeftHand}>
                      <Radio value='<3' />Less than 3 seconds
                      <br />
                      <Radio value='>3' />Greater than 3 seconds
                    </RadioGroup>
                  </td>
                </tr>
                <tr>
                  <td>Right hand: </td>
                  <td>
                    <RadioGroup field='cardiovascular.capRefillRightHand' initialValue={cardiovascular.capRefillRightHand}>
                      <Radio value='<3' />Less than 3 seconds
                      <br />
                      <Radio value='>3' />Greater than 3 seconds
                    </RadioGroup>
                  </td>
                </tr>
                <tr>
                  <td>Left foot: </td>
                  <td>
                    <RadioGroup field='cardiovascular.capRefillLeftFoot' initialValue={cardiovascular.capRefillLeftFoot}>
                      <Radio value='<3' />Less than 3 seconds
                      <br />
                      <Radio value='>3' />Greater than 3 seconds
                    </RadioGroup>
                  </td>
                </tr>
                <tr>
                  <td>Right foot: </td>
                  <td>
                    <RadioGroup field='cardiovascular.capRefillRightFoot' initialValue={cardiovascular.capRefillRightFoot}>
                      <Radio value='<3' />Less than 3 seconds
                      <br />
                      <Radio value='>3' />Greater than 3 seconds
                    </RadioGroup>
                  </td>
                </tr>
              </tbody>
            </table>
            <table>
              <tbody className={styles.topAlign}>
                <tr>
                  <td>Mucous membranes color: </td>
                  <td>
                    <RadioGroup field='cardiovascular.mucousMembraneColor' initialValue={cardiovascular.mucousMembraneColor}>
                      <Radio value='pink' />Pink
                      <br />
                      <Radio value='pale' />Pale
                      <br />
                      <Radio value='cyanotic' />Cyanotic
                    </RadioGroup>
                  </td>
                </tr>
                <tr>
                  <td>Mucous membranes moisture: </td>
                  <td>
                    <RadioGroup field='cardiovascular.mucousMembraneMoisture' initialValue={cardiovascular.mucousMembraneMoisture}>
                      <Radio value='moist' />Moist
                      <br />
                      <Radio value='dry' />Dry
                    </RadioGroup>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className={styles.section}>
            <SecondaryText>Tissue perfusion notes:</SecondaryText><br />
            <TextArea field='cardiovascular.tissuePerfNotes' initialValue={cardiovascular.tissuePerfNotes} />
          </div>
          <PrimaryText>Edema</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Edema: </SecondaryText><br />
            <RadioGroup field='cardiovascular.edema' initialValue={cardiovascular.edema}>
              <Radio value='no' />No edema noted<br />
              <Radio value='yes' />Generalized, nonpitting edema
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Upper extremities:</SecondaryText><br />
            <RadioGroup field='cardiovascular.upperEdema' initialValue={cardiovascular.upperEdema}>
              <Radio value='0' />Nonpitting<br />
              <Radio value='2' />Slight pitting (2mm)<br />
              <Radio value='4' />Deeper pitting (4mm)<br />
              <Radio value='6' />Deep pitting (6mm)<br />
              <Radio value='8' />Very deep pitting (8mm)
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Lower extremities:</SecondaryText><br />
            <RadioGroup field='cardiovascular.lowerEdema' initialValue={cardiovascular.lowerEdema}>
              <Radio value='0' />Nonpitting<br />
              <Radio value='2' />Slight pitting (2mm)<br />
              <Radio value='4' />Deeper pitting (4mm)<br />
              <Radio value='6' />Deep pitting (6mm)<br />
              <Radio value='8' />Very deep pitting (8mm)
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Edema notes:</SecondaryText><br />
            <TextArea field='cardiovascular.edemaNotes' initialValue={cardiovascular.edemaNotes} />
          </div>
          <PrimaryText>Cardiac Assessment</PrimaryText><br />
          <div className={styles.section}>
            <Checkbox field='cardiovascular.noCardiacProblems' initialValue={cardiovascular.noCardiacProblems} />No cardiac problems noted
          </div>
          <div className={styles.section}>
            <SecondaryText>Mark all that apply</SecondaryText><br />
            <Checkbox field='cardiovascular.dyspnea' initialValue={cardiovascular.dyspnea} />Dyspnea on exertion<br />
            <Checkbox field='cardiovascular.palpitations' initialValue={cardiovascular.palpitations} />Palpitations<br />
            <Checkbox field='cardiovascular.chestPainCont' initialValue={cardiovascular.chestPainCont} />Chest pain continuous<br />
            <Checkbox field='cardiovascular.chestPainPeriodic' initialValue={cardiovascular.chestPainPeriodic} />Chest pain periodic<br />
            <Checkbox field='cardiovascular.chestPainExert' initialValue={cardiovascular.chestPainExert} />Chest pain on exertion<br />
            <Checkbox field='cardiovascular.chestPainSudden' initialValue={cardiovascular.chestPainSudden} />Chest pain sudden onset<br />
            <Checkbox field='cardiovascular.tachycardia' initialValue={cardiovascular.tachycardia} />Tachycardia<br />
            <Checkbox field='cardiovascular.bradycardia' initialValue={cardiovascular.bradycardia} />Bradycardia<br />
            <Checkbox field='cardiovascular.hypotension' initialValue={cardiovascular.hypotension} />Postural hypotension<br />
            <Checkbox field='cardiovascular.hypertension' initialValue={cardiovascular.hypertension} />Hypertension<br />
            <Checkbox field='cardiovascular.distendedVeins' initialValue={cardiovascular.distendedVeins} />Distended neck veins
          </div>
          <div className={styles.section}>
            <SecondaryText>Cardiac notes:</SecondaryText><br />
            <TextArea field='cardiovascular.cardiacNotes' initialValue={cardiovascular.cardiacNotes} />
          </div>
        </div>
      </ContentBox>
    );
  }
}

export default EditCardiovascular;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/progressNote/edit/EditCardiovascular.jsx